<template>
  <section>
    <a-row type="flex" justify="space-between" class="container">
      <boxTitleMoudle
        class="weather"
        style="height: 99%; width: 29%"
        :left="'0px'"
        :title="'天气数据'"
      >
        <a-col :span="24" class="weather_box m-b-10" style="height: 35%">
          <img
            class="title_bg"
            src="../../assets/image/bg-image/future_weather.png"
            alt=""
          />
          <a-row type="flex" justify="space-between">
            <a-col
              :span="7"
              class="border-line"
              v-for="(item, ind) in futureThreeDaysData"
              :key="ind"
            >
              <p class="m-b-6">
                {{ item.days }}
                <span style="font-size: 12px">{{ item.week }}</span>
              </p>
              <p class="m-b-6">农历七月初六</p>
              <img
                class="m-b-6"
                :src="item.weather_icon"
                alt=""
                style="width: 44px"
              />
              <p class="m-b-6">
                <span class="weather_num">{{ item.temp_high }}</span
                ><span class="weather_unit">℃</span>
              </p>
              <p class="m-b-6">{{ item.temperature }}</p>
              <p class="m-b-6"><span class="status excellent">优</span></p>
              <p class="m-b-6" style="font-size: 10px">{{ item.wind }}</p>
            </a-col>
          </a-row>
        </a-col>
        <a-col :span="24" class="weather_box" style="height: 30%">
          <img
            class="title_bg"
            src="../../assets/image/bg-image/unusual_weather.png"
            alt=""
          />
          <history-error-weather style="width: 100%; height: 180px" />
        </a-col>
        <a-col :span="24" class="weather_box" style="height: 35%">
          <img
            class="title_bg"
            src="../../assets/image/bg-image/24houer_weather.png"
            alt=""
          />
          <a-row style="text-align: right">
            <a
              @click="activeKey = item.key"
              :style="{
                color:
                  item.key == activeKey ? '#1890ff' : 'rgba(255,255,255,0.8)',
              }"
              v-for="item in typeList"
              :key="item.key"
              class="m-r-16"
              >{{ item.title }}</a
            >
          </a-row>
          <hours-data-analysis
            :activeKey="activeKey"
            style="width: 100%; height: 70%"
          />
        </a-col>
      </boxTitleMoudle>

      <a-col style="height: 100%; width: 41%">
        <boxTitleMoudle class="monitor" :left="'0px'" :title="'环境监控'">
          <li class="tab_li">
            <a
              :class="
                currentDeviceEnviCurData.deviceCode === item.deviceCode
                  ? 'status'
                  : ''
              "
              v-for="(item, ind) in deviceEnviCurDataMap"
              :key="ind"
              >#{{ item.deviceCode }}</a
            >
          </li>
          <section class="monitor_top">
            <section class="pass">
              <section>
                <p style="font-size: 28px; color: #fff; margin-bottom: 2px">
                  <span>{{ currentDeviceEnviCurData.noise || 0 }}</span>
                  <span style="font-size: 18px">{{
                    currentDeviceEnviCurData.noiseUnit
                  }}</span>
                </p>
                <p class="m-b-8" style="color: #fff">噪声</p>
              </section>
            </section>
            <section class="fail">
              <section>
                <p style="font-size: 28px; color: #fff; margin-bottom: 2px">
                  <span>{{ currentDeviceEnviCurData.dust || 0 }}</span>
                  <span style="font-size: 18px">{{
                    currentDeviceEnviCurData.dustUnit
                  }}</span>
                </p>
                <p class="m-b-8" style="color: #fff">扬尘</p>
              </section>
            </section>
            <section class="pass pass2">
              <section>
                <p style="font-size: 28px; color: #fff; margin-bottom: 2px">
                  <span>{{ currentDeviceEnviCurData.temperature || 0 }}</span>
                  <span style="font-size: 18px">{{
                    currentDeviceEnviCurData.temperatureUnit
                  }}</span>
                </p>
                <p class="m-b-8" style="color: #fff">温度</p>
              </section>
            </section>
            <section class="pass pass3">
              <section>
                <p style="font-size: 28px; color: #fff; margin-bottom: 2px">
                  <span>{{ currentDeviceEnviCurData.humidity || 0 }}</span>
                  <span style="font-size: 18px">{{
                    currentDeviceEnviCurData.humidityUnit
                  }}</span>
                </p>
                <p class="m-b-8" style="color: #fff">湿度</p>
              </section>
            </section>
            <section class="pass pass4">
              <section>
                <p style="font-size: 28px; color: #fff; margin-bottom: 2px">
                  <span>{{ currentDeviceEnviCurData.speed || 0 }}</span>
                  <span style="font-size: 18px">{{
                    currentDeviceEnviCurData.speedUnit
                  }}</span>
                </p>
                <p class="m-b-8" style="color: #fff">风速</p>
              </section>
            </section>
            <section class="monitor_pic">
              <img
                class="banner-1"
                src="../../assets/image/bg-image/banner-1.png"
                alt=""
              />
              <img
                class="banner-2"
                src="../../assets/image/bg-image/banner-2.png"
                alt=""
              />
              <img
                class="banner-3"
                src="../../assets/image/bg-image/banner-3.png"
                alt=""
              />
              <section>
                <p
                  class="m-b-8"
                  style="font-size: 40px; color: rgba(0, 146, 255, 1)"
                >
                  优
                </p>
                <p class="m-b-8">55</p>
                <p class="m-b-8">空气质量得分</p>
              </section>
            </section>
          </section>
          <section class="monitor_bottom">
            <section class="status_list">
              <li class="color_list">
                <span style="background: rgba(64, 146, 255, 1)">
                  <b style="top: -19px; left: 0">0</b>
                  <b style="top: -19px; right: -5px">50</b>
                </span>
                <span style="background: rgba(255, 187, 56, 1)">
                  <b style="top: -19px; right: -5px">100</b>
                </span>
                <span style="background: rgba(253, 121, 22, 1)">
                  <b style="top: -19px; right: -5px">150</b>
                </span>
                <span style="background: rgba(252, 24, 93, 1)">
                  <b style="top: -19px; right: -5px">200</b>
                </span>
                <span style="background: rgba(171, 116, 255, 1)">
                  <b style="top: -19px; right: -5px">250</b>
                </span>
                <span
                  style="
                    background: rgba(99, 13, 0, 1);
                    color: rgba(99, 13, 0, 1);
                  "
                  >1
                  <b style="top: -19px; right: -5px; color: #fff">500</b>
                </span>
              </li>
            </section>
            <section class="status_list" style="margin-top: 0; height: 10px">
              <li>
                <span>优</span>
                <span>良</span>
                <span>轻度污染</span>
                <span>中度污染</span>
                <span>重度污染</span>
                <span>严重污染</span>
              </li>
            </section>
          </section>
        </boxTitleMoudle>

        <section class="workingWarm scroll-container">
          <p style="margin-bottom: 2px; font-size: 18px; color: #1890ff">
            施工提醒
          </p>
          <li>
            <img
              class="m-r-10"
              style="width: 20px"
              src="../../assets/image/bg-image/warm_tip_icon.png"
              alt=""
            />
            台风天气，请注意施工现场重型机械禁止作业，请注意材料堆放区注意材料码放及覆盖，放及覆注意防...
          </li>
          <li class="m-t-14">
            <img
              class="m-r-10"
              style="width: 20px"
              src="../../assets/image/bg-image/warm_tip_icon.png"
              alt=""
            />温度过高，请注意工人的防暑降温，加强个人防护，配备防暑降温药品，及时进行防暑降...
          </li>
          <li class="m-t-14">
            <img
              class="m-r-10"
              style="width: 20px"
              src="../../assets/image/bg-image/warm_tip_icon.png"
              alt=""
            />雨季施工小建议（基础阶段）1、土方开挖时，时刻观测降雨对护坡的影响，设置观测和及...
          </li>
          <li class="m-t-14">
            <img
              class="m-r-10"
              style="width: 20px"
              src="../../assets/image/bg-image/warm_tip_icon.png"
              alt=""
            />风速达5~6级,请注意扬尘覆盖；室内湿作业应尽量封闭，避免胶凝类材料开裂；外窗安装...
          </li>
          <li class="m-t-14">
            <img
              class="m-r-10"
              style="width: 20px"
              src="../../assets/image/bg-image/warm_tip_icon.png"
              alt=""
            />台风天气，请注意施工现场重型机械禁止作业，请注意材料堆放区注意材料码放及覆盖，放及覆注意防...
          </li>
        </section>
      </a-col>
      <a-col style="height: 100%; width: 29%">
        <boxTitleMoudle
          class="green"
          :left="'0px'"
          style="height: 60%"
          :title="'绿色施工'"
        >
          <section style="height: 50%">
            <img
              class="title_bg"
              src="../../assets/image/bg-image/warining_type.png"
              alt=""
            />
            <section class="des">单位/次</section>
            <early-warning-type style="width: 100%; height: 180px" />
            <!-- <div id="warnningType" style="width: 100%; height: 180px"></div> -->
          </section>

          <section style="height: 50%; position: relative">
            <img
              class="title_bg"
              src="../../assets/image/bg-image/level.png"
              alt=""
            />
            <section class="des" style="top: 20px; right: 11px">
              单位/数
            </section>
            <early-warning-level style="width: 100%; height: 70%" />
          </section>
        </boxTitleMoudle>

        <boxTitleMoudle
          :left="'0px'"
          :title="'设备预警记录'"
          class="record"
          style="height: 37%"
        >
          <div style="width: 100%; text-align: center; height: 95%">
            <li
              class="flex-bet"
              style="
                color: #95adce;
                display: flex;
                justify-content: space-between;
                text-align: center;
              "
            >
              <span style="flex: 1">序号</span>
              <span style="flex: 1">设备名称</span>
              <span style="flex: 1">预警类型</span>
              <span style="flex: 1">预警值</span>
              <span style="flex: 1">阈值</span>
            </li>
            <div style="overflow: hidden; height: 90%">
              <div style="height: 100%" class="anim">
                <textData :length="7" :textData="deviceEnviWarnLists">
                
                  <template v-slot:key="slotProps">
                    <span
                      class="text-overflow"
                      style="flex: 1; height: 30px; line-height: 30px"
                    >
                      {{ slotProps.val }}
                    </span>
                  </template>
                  <template v-slot:deviceName="slotProps">
                    <span
                      class="text-overflow"
                      style="flex: 1; height: 30px; line-height: 30px"
                    >
                      {{ slotProps.val }}
                    </span>
                  </template>
                  <template v-slot:typeName="slotProps">
                    <span
                      class="text-overflow"
                      style="flex: 1; height: 30px; line-height: 30px"
                    >
                      {{ slotProps.val }}
                    </span>
                  </template>
                  <template v-slot:value="slotProps">
                    <span
                      class="text-overflow"
                      style="flex: 1; height: 30px; line-height: 30px"
                    >
                      {{ slotProps.val }}
                    </span>
                  </template>
                  <template v-slot:threshold="slotProps">
                    <span
                      class="text-overflow"
                      style="flex: 1; height: 30px; line-height: 30px"
                    >
                      {{ slotProps.val }}
                    </span>
                  </template>
                </textData>
              </div>
            </div>
          </div>
        </boxTitleMoudle>
      </a-col>
    </a-row>
  </section>
</template>
<script>
import earlyWarningType from "./components/earlyWarningType"; //预警类型
import earlyWarningLevel from "./components/earlyWarningLevel"; //预警等级
import historyErrorWeather from "./components/historyErrorWeather"; //历史异常天气
import hoursDataAnalysis from "./components/hoursDataAnalysis"; //历史异常天气
import boxTitleMoudle from "@/components/BaseBoxTitleMoudle.vue";
import textData from "@/components/textData.vue";
export default {
  components: {
    earlyWarningType,
    earlyWarningLevel,
    historyErrorWeather,
    hoursDataAnalysis,
    boxTitleMoudle,
    textData,
  },
  data() {
    return {
      deviceEnviWarnLists: [],
      futureThreeDaysData: [],
      deviceEnviCurDataMap: [],
      currentDeviceEnviCurData: {},
      typeList: [
        { title: "温度", key: 0 },
        { title: "湿度", key: 1 },
        { title: "风速", key: 2 },
      ],
      //阀值
      thresholdMap: [
        { type: 2, typeName: "湿度", value: "60%" },
        { type: 3, typeName: "风速", value: "10.8m/s" },
      ],
      activeKey: 0,
      animate: false,
      spliceList: [],
      sliceData: [],
      ind: 0,
      scrollTime: null,
    };
  },
  created() {
    this.queryDeviceEnviWarnData();
    this.queryDeviceEnviCurData();
    this.queryDeviceWeatherDataFuture();
    // setInterval(this.scroll, 1000);
  },
  methods: {
    // 分割数组
    sliceArr(arr, len) {
      let newArr = []; //首先创建一个新的空数组。用来存放分割好的数组
      for (let i = 0; i < arr.length; ) {
        //注意：这里与for循环不太一样的是，没有i++
        newArr.push(arr.slice(i, (i += len)));
      }
      return newArr;
    },
    queryDeviceEnviCurData() {
      this.$api.queryDeviceEnviCurData({ size: 1 }).then((res) => {
        if (res.code === 200) {
          this.deviceEnviCurDataMap = (res.data && res.data.records) || [];
          this.currentDeviceEnviCurData = this.deviceEnviCurDataMap.length
            ? this.deviceEnviCurDataMap[0]
            : {};
        }
      });
    },
    //未来3天天气
    queryDeviceWeatherDataFuture() {
      this.$api.queryDeviceWeatherDataFuture().then((res) => {
        if (res.code === 200) {
          this.futureThreeDaysData = res.data || [];
        }
      });
    },
    queryDeviceEnviWarnData() {
      this.$api.queryDeviceEnviWarnData().then((res) => {
        if (res.code === 200) {
          this.deviceEnviWarnLists = (res.data && res.data.records) || [];
          this.deviceEnviWarnLists.forEach((item, ind) => {
            item.key = ind + 1;
            item.threshold = this.thresholdMap.filter(
              (v) => v.type == item.type
            )[0].value;
          });
          let mapList = [];
          this.deviceEnviWarnLists.forEach((item, ind) => {
            mapList.push({
              key: ind + 1,
              deviceName: item.deviceName,
              typeName: item.typeName,
              value: item.value,
              threshold: this.thresholdMap.filter((v) => v.type == item.type)[0]
                .value,
            });
          });
          this.deviceEnviWarnLists = mapList;

          
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.app-container {
  margin-top: 20px;
}
// .anim {
//   transition: all 0.5s;
//   margin-top: -236px;
// }
.container {
  height: 100%;
  // 天气
  .weather {
    .title_bg {
      width: 100%;
    }
    .weather_box {
      text-align: center;
      .border-line {
        border-right: 1px dashed #3f72ba;
      }
      .weather_num {
        font-size: 30px;
        color: #fff;
      }
      .weather_unit {
        vertical-align: top;
      }
      .status {
        display: inline-block;
        width: 50%;
        color: #fff;
        border-radius: 3px;
      }
      .excellent {
        background-color: #80cd7f;
      }
      .medium {
        background-color: #837fcd;
      }
      .bad {
        background-color: #c1844d;
      }
    }
  }
  // 监控
  .monitor {
    height: 72%;

    .tab_li {
      color: rgba(210, 210, 210, 1);
      span,
      a {
        color: #ffffff;
        margin-right: 20px;
        cursor: pointer;
      }
      .status {
        color: #84ffe9;
        &::before {
          content: "";
          width: 8px;
          display: inline-block;
          height: 8px;
          background: #84ffe9;
          margin-right: 8px;
          border-radius: 1px;
        }
      }
    }
    // 转动动画

    @keyframes rot {
      from {
        -webkit-transform: rotate(0deg);
      }

      to {
        -webkit-transform: rotate(360deg);
      }
    }
    @keyframes rot1 {
      from {
        -webkit-transform: rotate(360deg);
      }

      to {
        -webkit-transform: rotate(0deg);
      }
    }

    .monitor_top {
      width: 100%;
      height: 70%;
      position: relative;
      display: flex;
      justify-content: center;
      .monitor_pic {
        width: 367px;
        height: 367px;
        text-align: center;
        margin-top: 20px;
        display: flex;
        justify-content: center; /* 水平居中 */
        align-items: center; /* 垂直居中 */
        // background: url("../../assets/image/bg-image/monitor_pic.png") no-repeat;
        // background-size: 100% 100%;
        position: relative;
        top: 2%;
        .banner-1 {
          position: absolute;
          animation: rot 30s linear infinite;
          top: 0%;
        }
        .banner-2 {
          position: absolute;
          width: 86%;
          animation: rot1 30s linear infinite;
          top: 6%;
        }
        .banner-3 {
          position: absolute;
          width: 66%;
          animation: rot 30s linear infinite;
          top: 16%;
        }
      }
      .pass {
        width: 100px;
        height: 97px;
        text-align: center;
        position: absolute;
        left: 11%;
        top: 3%;
        background: url("../../assets/image/bg-image/pass.png") no-repeat;
        background-size: 100% 100%;
        display: flex;
        justify-content: center; /* 水平居中 */
        align-items: center; /* 垂直居中 */
        color: #fff !important;
        // animation: icon 1s linear infinite;
      }
      .fail {
        width: 100px;
        height: 97px;
        position: absolute;
        left: 11%;
        top: 80%;
        justify-content: center; /* 水平居中 */
        align-items: center; /* 垂直居中 */
        text-align: center;
        color: #fff !important;
        background: url("../../assets/image/bg-image/fail.png") no-repeat;
        background-size: 100% 100%;
        // animation: icon 1s linear infinite;
      }
      @keyframes icon {
        0% {
          opacity: 1;
          transform: translate(0, 0);
        }
        50% {
          opacity: 1;
          transform: translate(3px, 3px);
        }
        100% {
          opacity: 1;
          transform: translate(0, 0);
        }
      }
      .pass2 {
        left: 3%;
        top: 41%;
        // animation: icon 1s linear infinite;
      }
      .pass3 {
        left: 81%;
        top: 55%;
        // animation: icon 1s linear infinite;
      }
      .pass4 {
        left: 81%;
        top: 5%;
        // animation: icon 1s linear infinite;
      }
    }
    .monitor_bottom {
      margin-top: 40px;
      width: 100%;
      background: url("../../assets/image/bg-image/monitor_bottom.png")
        no-repeat;
      background-size: 100% 100%;
      height: 15%;
      // display: flex;
      // justify-content: center; /* 水平居中 */
      // align-items: center; /* 垂直居中 */
      .status_list {
        width: 100%;
        display: flex;
        justify-content: center; /* 水平居中 */
        align-items: center; /* 垂直居中 */

        li {
          text-align: center;
          width: 70%;
          margin-top: 20px;
          display: flex;
          height: 10px;
          span {
            flex: 1;
          }
        }
      }
      .color_list {
        span {
          position: relative;
          b {
            position: absolute;
            top: 0;
          }
        }
      }
    }
  }

  // 施工提醒
  .workingWarm {
    height: 26%;
    margin-top: 10px;
    background: url("../../assets/image/bg-image/working_warm.png") no-repeat;
    background-size: 100% 100%;
    padding: 10px 20px;
  }

  // 绿色施工
  .green {
    height: 62%;

    position: relative;
    .title_bg {
      width: 100%;
    }
    .des {
      position: absolute;
      right: 26px;
      top: 79px;
    }
  }

  .record {
    margin-top: 20px;
    .flex-bet {
      display: flex;
      justify-content: space-between;
      text-align: center;
      height: 30px;
      line-height: 30px;

      span {
        flex: 1;
      }
    }
    .safeData {
      background: rgba(39, 73, 121, 1);
      margin-top: 4px;
      height: 14.6%;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
}
p {
  // margin-bottom: 0;
  color: #d2d2d2;
}
li {
  list-style: none;
}
</style>